import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    setScrollProgress(docHeight > 0 ? latest / docHeight * 100 : 0);
  });
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0a]/90 backdrop-blur-md border-b border-[#C9A84C]/20 py-3' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-230">
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-white/5" data-id="element-231">
        <motion.div className="h-full bg-[#C9A84C] origin-left" style={{
        width: `${scrollProgress}%`
      }} transition={{
        duration: 0.1
      }} data-id="element-232" />
      </div>

      <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-233">
        <div className="flex items-center gap-2" data-id="element-234">
          <span className="text-2xl font-bold text-[#C9A84C] font-['Bebas_Neue'] tracking-widest" data-id="element-235">
            DOMINIO MENTAL
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8" data-id="element-236">
          <a href="#programa" className="text-sm font-medium text-gray-300 hover:text-[#C9A84C] transition-colors uppercase tracking-wide" data-id="element-237">
            Programa
          </a>
          <a href="#historia" className="text-sm font-medium text-gray-300 hover:text-[#C9A84C] transition-colors uppercase tracking-wide" data-id="element-238">
            Historia
          </a>
          <a href="#precio" className="text-sm font-medium text-gray-300 hover:text-[#C9A84C] transition-colors uppercase tracking-wide" data-id="element-239">
            Inversión
          </a>
          <Button size="sm" onClick={() => window.open('https://pzhbwp-zj.myshopify.com/cart/43946659938439:1', '_blank')} data-id="element-240">
            EMPEZAR
          </Button>
        </div>

        <div className="md:hidden" data-id="element-241">
          <Button size="sm" onClick={() => window.open('https://pzhbwp-zj.myshopify.com/cart/43946659938439:1', '_blank')} data-id="element-242">
            EMPEZAR
          </Button>
        </div>
      </div>
    </motion.nav>;
}